var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-menu',_vm._g(_vm._b({attrs:{"offset-y":"","close-on-content-click":false,"content-class":_setup.contentClass},scopedSlots:_vm._u([{key:"activator",fn:function(data){return [_vm._t("trigger",null,null,data)]}}],null,true)},'v-menu',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }